import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    items: getDefaultAsyncWrapperObj(),
};
// Action Types
const actionTypesPrefix = 'loadDataSourceOverrideList';
export const dataSourceOverrideListActionTypes = {
    LOAD: `${actionTypesPrefix}/LOAD`,
    LOADING: `${actionTypesPrefix}/LOADING`,
    LOADED: `${actionTypesPrefix}/LOADOADED`,
};
// Action Creators
export const dataSourceOverrideListLoadAction = (workspaceId, dataSourceName) => {
    return {
        type: dataSourceOverrideListActionTypes.LOAD,
        payload: { workspaceId: workspaceId, dataSourceName: dataSourceName },
    };
};
export const dataSourceOverrideListLoadingAction = (payload) => {
    return {
        type: dataSourceOverrideListActionTypes.LOADING,
        payload: payload,
    };
};
export const dataSourceOverrideListLoadedAction = (payload, result) => {
    return {
        type: dataSourceOverrideListActionTypes.LOADED,
        payload: {
            items: result,
        },
    };
};
// Reducer
export const reducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case dataSourceOverrideListActionTypes.LOADING:
            return {
                ...state,
                items: {
                    ...state.items,
                    status: AsyncRequestStatus.Pending,
                },
            };
        case dataSourceOverrideListActionTypes.LOADED:
            const loadedAction = action;
            return {
                ...state,
                items: loadedAction.payload.items,
            };
        default:
            return state;
    }
};
export default reducer;

//# sourceMappingURL=DataSourceDetailOverrideList.ducks.js.map
